module.exports = __webpack_public_path__ + "static/media/Eren_Kamiyama.6ba8f311.jpg";